@if (options(); as mapOptions) {
  <!-- [autoResize] basta cuando cambia la altura: ngx-echarts observa este mismo
       div con un ResizeObserver, que dispara igual por alto que por ancho. -->
  <div echarts
       class="map"
       [options]="mapOptions"
       [style.height.px]="scaledHeight()"
       [autoResize]="true"
       (chartInit)="chartReady.emit($event)"></div>
} @else {
  <div class="map map--placeholder" [style.height.px]="scaledHeight()">
    <i class="bi bi-globe-americas" aria-hidden="true"></i>
    <span>Cargando mapa…</span>
  </div>
}

<div class="z-legend map-legend">
  <span><i class="dot dot--detractor" aria-hidden="true"></i> Detractor</span>
  <span><i class="dot dot--pasivo" aria-hidden="true"></i> Pasivo</span>
  <span><i class="dot dot--promotor" aria-hidden="true"></i> Promotor</span>
</div>
